import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { PersonalDataFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';

interface PersonalDataStepProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const PersonalDataStep: React.FC<PersonalDataStepProps> = ({
    context,
    collaboratorId,
    control,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="p-4 sm:p-6">
            <PersonalDataFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                errors={errors}
                isSubmitting={isSubmitting}
            />
        </div>
    );
};

export default PersonalDataStep;
